import { InternalAxiosRequestConfig } from 'axios'

export const requestTokenInterceptor = (
  config: InternalAxiosRequestConfig,
  partnerPublicKey: string | undefined
): InternalAxiosRequestConfig => {
  if (partnerPublicKey && !config.withCredentials) {
    return {
      ...config,
      headers: {
        Authorization: partnerPublicKey,
        ...config.headers
      }
    } as unknown as InternalAxiosRequestConfig
  }

  return config
}
